import { useEffect, useState } from "react";
import { Draft, DRAFT_KEY, DISABLED_KEY, readDraft } from "./otlDraft";

export interface OtlDraftRecovery {
  period: string;
  draft?: Draft;
  discardedDraft: boolean;
  enabled: boolean;
  error: boolean;
}

export function useOtlDraftRecovery(period: string): OtlDraftRecovery | null {
  const [recovery, setRecovery] = useState<OtlDraftRecovery | null>(null);
  useEffect(() => {
    try {
      const hadDraft = localStorage.getItem(DRAFT_KEY) !== null;
      const draft = readDraft(localStorage, period);
      setRecovery({
        period,
        draft,
        discardedDraft: hadDraft && !draft,
        enabled: localStorage.getItem(DISABLED_KEY) !== "true",
        error: false,
      });
    } catch {
      setRecovery({
        period,
        enabled: false,
        error: true,
        discardedDraft: false,
      });
    }
  }, [period]);
  // A changed period must never render a form using the previous period's recovery.
  return recovery?.period === period ? recovery : null;
}
